
  $(function() {
    const { hostname } = location;
    
    let baseUrl = 'https://dev-api.meixin.57blocks.io';
  
    if (hostname.includes('upmarket')) {
      baseUrl = 'https://api.upmarket.co';
    } else if (hostname.includes('qa.')) {
      baseUrl = 'https://qa-api.meixin.57blocks.io';
    }
  
    const instance = axios.create({ baseURL: baseUrl });
  
    instance.interceptors.request.use(
      (config) => {
        config.headers.language = localStorage.getItem('language');
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  
    instance.interceptors.response.use(
      (response) => {
        return response.data || response;
      },
      async (error) => {
        return Promise.reject(error.response);
      }
    );
  
    window.$http = instance;

  })